import type { CertificateTemplateId } from '../types/certificateTemplate';

export type MockCertificateTemplate = {
  associatedCourses: Array<{
    id: number;
    name: string;
  }>;
  id: number;
  templateId: CertificateTemplateId;
  displayName: string;
  category: 'Competenza' | 'ECM Sanita';
  lastUpdated: string;
  previewCourseId: number;
};

export const MOCK_CERTIFICATE_TEMPLATES: MockCertificateTemplate[] = [
  {
    id: 1,
    templateId: 'cert3',
    displayName: 'Certificato di competenza BECOME',
    category: 'Competenza',
    associatedCourses: [
      { id: 8, name: '8 - Corso di competenza professionale' },
      { id: 15, name: '15 - Competenze cliniche avanzate' },
      { id: 21, name: '21 - Psicologia applicata al lavoro' },
      { id: 26, name: '26 - Comunicazione terapeutica' },
      { id: 33, name: '33 - Gestione casi complessi' },
      { id: 37, name: '37 - Counseling in pratica' },
      { id: 41, name: '41 - Assessment psicologico' },
      { id: 44, name: '44 - Psicodiagnostica base' },
      { id: 49, name: '49 - Soft skills per clinici' },
      { id: 53, name: '53 - Relazione terapeuta-utente' },
      { id: 58, name: '58 - Etica professionale' },
      { id: 61, name: '61 - Interventi brevi efficaci' },
      { id: 66, name: '66 - Psicologia della salute' },
      { id: 70, name: '70 - Gestione setting online' },
    ],
    lastUpdated: '2026-03-24',
    previewCourseId: 8,
  },
  {
    id: 2,
    templateId: 'cert2',
    displayName: 'Attestazione ECM - Formazione continua sanita',
    category: 'ECM Sanita',
    associatedCourses: [],
    lastUpdated: '2026-03-24',
    previewCourseId: 12,
  },
  {
    id: 3,
    templateId: 'cert1',
    displayName: 'Certificato di competenza BECOME + firma Francesca',
    category: 'Competenza',
    associatedCourses: [],
    lastUpdated: '2026-03-24',
    previewCourseId: 8,
  },
];
